/* eslint-disable no-unused-vars */
import { useState } from "react";
import React from "react";
import safeLogger from "../../utils/safeLogger";
import { Link } from "react-router-dom";

const initialState = {
  name: "",
  email: "",
  message: "",
};
const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [charCount, setCharCount] = useState(500);
  // eslint-disable-next-line no-unused-vars
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newErrors = { ...errors };

    // Limitação de caracteres para Nome e Mensagem
    if (name === "name" && value.length > 50) return;
    if (name === "message") setCharCount(500 - value.length);

    // Validação de e-mail
    if (name === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      newErrors.email = "E-mail inválido!";
    } else {
      delete newErrors.email;
    }

    setErrors(newErrors);
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => {
    setState({ ...initialState });
    setCharCount(500);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let validationErrors = {};

    if (!name.trim()) validationErrors.name = "Nome é obrigatório!";
    if (!email.trim()) validationErrors.email = "E-mail é obrigatório!";
    if (!message.trim()) validationErrors.message = "Mensagem é obrigatória!";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const response = await fetch("https://codefort.onrender.com/api/send-contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message }),
      });

      const data = await response.json();
      if (response.ok) {
        // Somente feedback para o usuário — não logar dados sensíveis retornados pelo servidor
        setSuccessMessage("Mensagem enviada com sucesso!");
        setTimeout(() => setSuccessMessage(""), 5000);
        clearState();
      } else {
        safeLogger.error("Erro ao enviar e-mail");
      }
    } catch (error) {
      safeLogger.error("Erro na requisição");
    }
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          {/* Formulário no lado esquerdo */}
          <div className="contact-form">
            <div className="section-title">
              <h2>Entre em Contato</h2>
              <p>
                Preencha o formulário abaixo para nos enviar um e-mail e
                entraremos em contato com você o mais breve possível.
              </p>
            </div>
            <form name="sentMessage" validate onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                      placeholder="Nome"
                      required
                      onChange={handleChange}
                      value={name}
                    />
                    {errors.name && <p className="error-text">{errors.name}</p>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      placeholder="E-mail"
                      required
                      onChange={handleChange}
                      value={email}
                    />
                    {errors.email && (
                      <p className="error-text">{errors.email}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-group">
                <textarea
                  name="message"
                  id="message"
                  className="form-control"
                  rows="4"
                  placeholder="Mensagem"
                  required
                  onChange={handleChange}
                  value={message}
                ></textarea>
                <p className="char-count">Restantes: {charCount} caracteres</p>
                {errors.message && (
                  <p className="error-text">{errors.message}</p>
                )}
              </div>
              {successMessage && (
                <p className="success-message">{successMessage}</p>
              )}
              <button type="submit" className="btn btn-custom btn-lg">
                Enviar Mensagem
              </button>
            </form>
          </div>

          {/* Informações de contato no lado direito */}
          <div className="contact-info">
            <h3>Informações de Contato</h3>
            <p>
              <span>
                <i className="fa fa-map-marker"></i> Endereço:
              </span>{" "}
              {props.data ? props.data.address : "loading"}
            </p>
            <p>
              <span>
                <i className="fa fa-phone"></i> Telefone:
              </span>{" "}
              {props.data ? props.data.phone : "loading"}
            </p>
            <p>
              <span>
                <i className="fa fa-envelope"></i> E-mail:
              </span>{" "}
              {props.data ? props.data.email : "loading"}
            </p>
          </div>
        </div>

        {/* Ícones sociais abaixo de tudo */}
        <div className="social">
          <ul>
            <li>
              <a href={props.data ? props.data.facebook : "/"}>
                <i className="fa-brands fa-instagram"></i>
              </a>
            </li>
            <li>
            <a href={props.data?.linkedin || "#"} target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-linkedin"></i>
              </a>
            </li>
            <li>
              <a href={props.data ? props.data.youtube : "/"}>
                <i className="fa-brands fa-youtube"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div id="footer">
        <div className="container">
          <p>
            © {new Date().getFullYear()} CodeFort <br />
            Todos os direitos reservados
          </p>
          <Link
            to="/privacy-policy"
            style={{
              textDecoration: "none",
              color: "inherit",
              fontWeight: "bold",
            }}
          >
            Política de Privacidade
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Contact;
